// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Digital World Universe - Warp Gates Configuration
 * 
 * Digital portals connecting the Digital World to other dimensions.
 */

export const warpGates = [
  {
    id: 'gate_digiworld_to_pokemon',
    name: 'Data Stream Portal',
    type: 'warpgate',
    distance: 25, // Distance from File Island
    coordinates: { x: 50, y: 60, z: 5 },
    destinationUniverse: 'pokemon',
    destinationGate: 'gate_pokemon_to_digiworld',
    toSystem: 600, // Kanto Prime
    fuelRequired: 5,
    threat: 'SAFE',
    resources: 'GATEWAY',
    services: [],
    primaryColor: '#00ffff',
    secondaryColor: '#ff00ff',
    hasRings: true,
    animated: true,
    discovered: true,
    description: 'Digital portal to the Pokémon universe. Data streams converge with biological evolution patterns. Cross-dimensional creature exchange possible.',
    scanDescription: 'ANALYSIS: Gateway to "Pokémon Universe" detected. Destination: Kanto Prime system. Digital-biological interface active. Evolution data compatible. Gate travel does not consume fuel.'
  },
  {
    id: 'gate_digiworld_to_neonmetropolis',
    name: 'Cyber Gateway',
    type: 'warpgate',
    distance: 100, // Distance from File Island
    coordinates: { x: 40, y: 65, z: 10 },
    destinationUniverse: 'neonmetropolis',
    destinationGate: 'gate_neonmetropolis_to_digiworld',
    toSystem: 1300, // Neo-Tokyo
    fuelRequired: 5,
    threat: 'MODERATE',
    resources: 'CYBER INTERFACE',
    services: [],
    primaryColor: '#00ffff',
    secondaryColor: '#ffff00',
    hasRings: true,
    animated: true,
    discovered: false,
    description: 'Unstable cyber-link to the Neon Metropolis. Corporate firewalls detected. Digital entities may be corrupted by corporate data streams.',
    scanDescription: 'ANALYSIS: Gateway to "Neon Metropolis" detected. Destination: Neo-Tokyo system. Corporate encryption: ACTIVE. Data corruption risk: MODERATE. Firewall penetration required. Gate travel does not consume fuel.'
  },
  {
    id: 'gate_digiworld_to_marioworld',
    name: 'Analog Portal',
    type: 'warpgate',
    distance: 25, // Distance from File Island
    coordinates: { x: 40, y: 55, z: 5 },
    destinationUniverse: 'marioworld',
    destinationGate: 'gate_marioworld_to_digiworld',
    toSystem: 1000, // Mushroom Kingdom
    fuelRequired: 5,
    threat: 'SAFE',
    resources: 'GATEWAY',
    services: [],
    primaryColor: '#00ffff',
    secondaryColor: '#ff00ff',
    hasRings: true,
    animated: true,
    discovered: false,
    description: 'Analog Portal - A gateway to a universe of pipes and platforms. Digital meets analog.',
    scanDescription: 'ANALYSIS: Gateway to "Mario World" detected. Destination: Mushroom Kingdom system. Analog-digital interface active. Platform data compatible. Gate travel does not consume fuel.'
  }
];

// Warp gate positions on the map
export const warpGatePositions = warpGates.reduce((acc, gate) => {
  acc[gate.id] = gate.coordinates;
  return acc;
}, {});